module.exports = __webpack_public_path__ + "static/media/icon-withdraw-with-border.241ed288.svg";